import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
      <div style={{
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e8e8e8'
      }}>
        {/* Main Footer Content */}
        <div style={{
          padding: '60px 5%',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <div className='row'>
            {/* Company Column */}
            <div className='col-md-6 mb-4'>
              <h4 style={{
                fontSize: '18px',
                fontWeight: '700',
                color: '#2c3e50',
                marginBottom: '25px',
                letterSpacing: '0.5px'
              }}>
                Company
              </h4>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    About us
                  </a>
                </li>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    Contact
                  </a>
                </li>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    Blog
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal Column */}
            <div className='col-md-6 mb-4'>
              <h4 style={{
                fontSize: '18px',
                fontWeight: '700',
                color: '#2c3e50',
                marginBottom: '25px',
                letterSpacing: '0.5px'
              }}>
                Legal
              </h4>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    Pre-Contractual Information Form
                  </a>
                </li>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    Privacy Policy / GDPR
                  </a>
                </li>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    Commercial User Terms and Conditions
                  </a>
                </li>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    General Terms and Conditions
                  </a>
                </li>
                <li style={{ marginBottom: '12px' }}>
                  <a href="#" style={{
                    textDecoration: 'none',
                    color: '#5c636c',
                    fontSize: '14px',
                    fontWeight: '400',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#4db8cd'}
                  onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                  >
                    Distance Selling Contract
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div style={{
          borderTop: '1px solid #e8e8e8',
          padding: '25px 5%',
          backgroundColor: '#fff'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            <div className='row align-items-center'>
              {/* Payment Methods */}
              <div className='col-md-6 mb-3 mb-md-0'>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  flexWrap: 'wrap'
                }}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" 
                    alt="Visa" 
                    style={{ height: '24px' }} 
                  />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" 
                    alt="Mastercard" 
                    style={{ height: '30px' }} 
                  />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/3/30/American_Express_logo.svg" 
                    alt="American Express" 
                    style={{ height: '24px' }} 
                  />
                </div>
              </div>

              {/* Social Media */}
              <div className='col-md-6'>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: '12px'
                }}>
                  <a href="#" style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    border: '1px solid #e0e0e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#4db8cd';
                    e.currentTarget.style.backgroundColor = '#4db8cd';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#e0e0e0';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  >
                    <i className="bi bi-instagram" style={{
                      fontSize: '16px',
                      color: '#5c636c'
                    }}
                    onMouseEnter={(e) => e.target.style.color = '#fff'}
                    onMouseLeave={(e) => e.target.style.color = '#5c636c'}
                    ></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Copyright & Info */}
            <div className='row' style={{ marginTop: '25px' }}>
              <div className='col-md-6 mb-2'>
                <p style={{
                  fontSize: '13px',
                  color: '#8895a7',
                  margin: 0,
                  fontWeight: '400'
                }}>
                  © 2025 All Rights Reserved Design by <span style={{ color: '#4db8cd', fontWeight: '600' }}>Holideus</span>
                </p>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    )
  }
}